<template>
  <div class="n_continer n_dynamic">
    <div class="n_padd">
      <div class="n_title">{{info.title}}</div>
      <!-- <div class="flex n_user just_space align_center">
        <div class="flex n_img">
          <img :src="info.image" alt />
          <div>
            <p class="n_name">{{info.author}}</p>
            <p class="n_time">{{info.release_time}}</p>
          </div>
        </div>
        <div class="n_relation">联系TA</div>
      </div>-->
      <div class="n_introduction">
        <p class="n_text">前言</p>
        <div class="n_conttxt">{{info.short_title}}</div>
      </div>
      <div class="n_rich">
        <div class="n_html" v-html="info.content"></div>
      </div>
    </div>
    <div class="n_fixed" @click="showShare = true">
      <img :src="imgPath + 'yj_share_btn.png'" alt />
    </div>
    <div class="fixed_jump" @click="isJump  = true" v-if="!isJump">
      <img :src="imgPath + 'yj_navbtn.png'" alt />
    </div>
    <div :class="['jump_fiex' ,'flex']" v-if="isJump">
      <!-- <img :src="imgPath + 'yj_navbtn.png'" alt /> -->
      <div class="alitem_center" @click="isJump = false">
        <span class="iconfont iconyousanjiao"></span>
        <span>导航</span>
      </div>
      <div class="n_tac" @click="jump('./homeIndex',0)">
        <span class="iconfont iconshangdian- fongs"></span>
        <p>商城</p>
      </div>
      <div class="n_tac" @click="jump('./social',1)">
        <span class="iconfont iconshejiao fongs"></span>
        <p>社交</p>
      </div>
      <div class="n_tac" @click="jump('./website',2)">
        <span class="iconfont iconguanwang fongs"></span>
        <p>官网</p>
      </div>
      <div class="n_tac" @click="jump('./dynamic',3)">
        <span class="iconfont icondongtai fongs"></span>
        <p>动态</p>
      </div>
      <div class="n_tac" @click="jump('./my',4)">
        <span class="iconfont iconxiugaitouxiang fongs"></span>
        <p>我的</p>
      </div>
    </div>
    <van-share-sheet v-model="showShare" title="立即分享" :options="options" @select="onSelect" />
    <!-- 分享提示 -->
    <van-overlay :show="show" @click="show = false">
      <div class="wrapper" @click.stop>
        <img :src="imgPath + 'yj_share.png'" alt />
        <img @click="show = false" class="n_shareBtn" :src="imgPath + 'byj_utton.png'" alt />
      </div>
    </van-overlay>
  </div>
</template>

<script>
import share from '../public/share.js'
import wx from 'weixin-js-sdk'
export default {
  data() {
    return {
      showShare: false,
      options: [
        { name: '微信', icon: 'wechat' },
        { name: '朋友圈', icon: 'wechat-moments' },
        // { name: '复制链接', icon: 'link' },
        // { name: '分享海报', icon: 'poster' },
        // { name: '二维码', icon: 'qrcode' },
      ],
      id: null,
      info: {},
      show: false,
      isJump: false,
    }
  },
  mounted() {
    this.prohibitweixinShare()
    this.id = this.$route.query.id
    this.getDetails()
  },
  watch: {
    '$store.state.shareStr': function (e) {
      if (e == 'dynamicDetails') {
        this.shareModelFg()
      }
    },
  },
  methods: {
    jump(e, a) {
      this.$router.push({ path: e })
      this.$store.commit('activeFailure', a)
    },
    onSelect(e) {
      console.log(e)
      if (e.name == '微信' || e.name == '朋友圈') {
        this.show = true
        this.showShare = false
      }
    },
    //获取url字符串
    getStringFg(url) {
      let hrr = []
      let obj = {}
      //截取内部参数
      let params = url.substr(url.indexOf('?') + 1)
      //逗号隔开
      let str = params.replace(/\&/g, ',')
      console.log(str)
      let crr = []
      str.split(',').map((i, index) => {
        crr.push(i.replace(/\=/g, ',').split())
      })
      console.log(crr)
      crr.map((item) => {
        item.forEach((i) => {
          hrr.push(i.split(','))
        })
      })
      hrr.map((item) => {
        obj[item[0]] = item[1]
      })
      localStorage.setItem('shareInfo', JSON.stringify(obj))
      if (obj.type == 'share') {
        this.shareExtensionFg(obj)
      } else if (JSON.parse(localStorage.getItem('shareInfo')).uid) {
        this.shareExtensionFg(JSON.parse(localStorage.getItem('shareInfo')))
      }
      console.log(obj)
    },
    //分享关系
    async shareExtensionFg(obj) {
      let res = await this.http('Client.shareExtension', {
        share_member_id: obj.uid,
        share_staff_id: obj.share_staff_id || 0,
        scenes: obj.scenes,
        extend_id: obj.id,
      })
      localStorage.setItem('shareId', res.content.share_sign_no)
      // 查看是否有红包
      if (res.content.share_sign_no) {
        this.receiveShareRedPacket(res.content.share_sign_no)
      }
    },
    // 领取分享新用户得红包  有分享关系请求
    receiveShareRedPacket(id) {
      this.http('MemberRedPacket.receiveShareRedPacket', {
        share_sign_no: id,
      }).then((e) => {
        console.log(e)
      })
    },
    shareModelFg() {
      let uid
      if (localStorage.getItem('userInfo')) {
        uid = JSON.parse(localStorage.getItem('userInfo')).id
      } else {
        return
      }
      let url =
        window.location.href.split('?')[0] +
        '?id=' +
        this.id +
        '&type=share' +
        '&uid=' +
        uid +
        '&scenes=article'

      wx.showMenuItems({
        menuList: ['menuItem:share:appMessage', 'menuItem:share:timeline'], // 要隐藏的菜单项，只能隐藏“传播类”和“保护类”按钮，所有menu项见附录3
      })

      let shareInfo = {
        title: this.info.title,
        desc: this.info.short_title,
        link: url, // 分享链接，该链接域名必须与当前企业的可信域名一致'
        imgUrl: this.info.image,
      }
      wx.onMenuShareAppMessage(shareInfo)
      wx.onMenuShareTimeline(shareInfo)
    },
    async getDetails() {
      let { content } = await this.http('ClientArticle.articleInfo', {
        article_id: this.id,
      })
      this.getStringFg(window.location.href)
      this.info = content

      if (this.$store.state.shareStr != 'dynamicDetails') {
        new share(
          {
            startUrl: window.location.href,
          },
          this.$store,
          'dynamicDetails'
        )
      } else {
        this.shareModelFg()
      }
      // let uid
      // if (localStorage.getItem('userInfo')) {
      //   uid = JSON.parse(localStorage.getItem('userInfo')).id
      // } else {
      //   uid = ''
      // }
      // new share({
      //   goods: {
      //     goods_name: content.title,
      //     content: content.short_title,
      //     images: content.image,
      //   },
      //   url:
      //     window.location.href.split('?')[0] +
      //     '&type=share' +
      //     '&uid=' +
      //     uid +
      //     '&scenes=article',
      //   startUrl: window.location.href,
      // })
    },
  },
}
</script>
<style>
.n_dynamic .n_html img {
  width: 100% !important;
  height: auto !important;
}
.n_dynamic .n_html p {
  width: 100% !important;
}
</style>
<style lang="scss" scoped>
.n_title {
  font-weight: 700;
}
.alitem_center {
  display: flex;
  align-items: center;
  margin-left: 20px;
  color: #fff;
  font-size: 24px;
  margin-right: 20px;
}
.iconyousanjiao {
  color: #fff;
  font-size: 34px;
}
.fongs {
  font-size: 32px;
  color: #fff;
}
.jump_fiex {
  width: 507px;
  position: fixed;
  right: 0;
  bottom: 100px;
  background: rgba(0, 0, 0, 0.6);
  border-radius: 200px 0 0 200px;
  margin-left: 20px;
}
.anitmion {
  animation: mymove 1.5s ease;
  animation-fill-mode: forwards;
}
@keyframes mymove {
  from {
    right: -400px;
  }
  to {
    right: 0px;
  }
}

@-webkit-keyframes mymove /*Safari and Chrome*/ {
  from {
    right: 0px;
  }
  to {
    right: 200px;
  }
}
.n_tac {
  text-align: center;
  color: #fff;
  font-size: 28px;
  padding: 10px 0;
  margin-right: 20px;
}
.fixed_jump {
  position: fixed;
  right: -34px;
  bottom: 100px;
  width: 122px;
  height: 80px;
}
.jump_fiex img {
  width: 122px;
  height: 80px;
}
.n_shareBtn {
  display: block;
  width: 236px !important;
  margin: 400px auto 0;
}
.n_continer {
  height: 100%;
  background: rgba(255, 255, 255, 1);
}
.n_padd {
  padding: 38px 50px;
}
.n_img img {
  width: 68px !important;
  height: 68px;
  margin-right: 6px;
}
.n_name {
  font-size: 26px;
  color: #000000;
}
.n_time {
  font-size: 20px;
  color: #a4a4a4;
}
.n_user {
  margin-top: 38px;
  background: #f7f8fa;
  border-radius: 44px;
  padding: 12px 20px;
}
.just_space {
  justify-content: space-between;
}
.align_center {
  align-items: center;
}
.n_relation {
  font-size: 24px;
  color: #ffffff;
  padding: 14px 20px;
  background: #ee0a24;
  border-radius: 31px;
}
.n_text {
  position: relative;
  font-size: 32px;
  color: #333333;
  font-weight: 700;
  margin-left: 20px;
}
.n_text::after {
  position: absolute;
  left: -18px;
  top: 5px;
  content: '';
  width: 6px;
  height: 36px;
  background: #d8d8d8;
}
.n_introduction {
  padding: 30px;
  background: #f7f8fa;
  border-radius: 20px 30px 20px 20px;
  margin-top: 30px;
}
.n_conttxt {
  margin-top: 16px;
  font-size: 28px;
  color: #9b9b9b;
  padding-bottom: 54px;
}
.n_rich {
  width: 100%;
  margin-top: 30px;
  word-break: break-all;
}
.n_html {
  word-break: break-all;
}
.n_fixed {
  position: fixed;
  bottom: 200px;
  right: 0px;
  width: 80px;
  height: 80px;
}
img {
  width: 100%;
  height: 100%;
}
</style>>
